import classcat from "classcat";
import React from "react";

import { Image } from "@is/components/Image";
import { MediaVariants } from "@is/constants";
import { HowToWearItWidget } from "@is/types";

import css from "./HTWIItemThumbnail.module.css";
import useManageHTWIItemThumbnail from "./hooks/useManageHTWIItemThumbnail";

type Props = {
  item: HowToWearItWidget;
  index: number;
  activeIndex: number;
  onThumbnailClick: (index: number) => void;
};

const HTWIItemThumbnail = ({
  item,
  index,
  activeIndex,
  onThumbnailClick,
}: Props) => {
  const { thumbnailItem, handleThumbnailClick } = useManageHTWIItemThumbnail({
    item,
    index,
    onThumbnailClick,
  });

  return (
    <button
      key={thumbnailItem.id}
      className={classcat([
        css.thumbnail,
        { [css.selected]: index === activeIndex },
      ])}
      data-index={index}
      onClick={handleThumbnailClick}
    >
      {thumbnailItem.modelShotUrl ? (
        <Image
          src={thumbnailItem.modelShotUrl}
          mediavariant={MediaVariants.MEDIUM_CROPPED_WITH_BACKGROUND_REMOVED}
          placeholderMediaVariant={
            MediaVariants.THUMBNAIL_CROPPED_WITH_BACKGROUND_REMOVED
          }
          className={css.thumbnailModelShot}
          showloadingspinner
          layout="cover"
        />
      ) : (
        thumbnailItem.thumbnailMedia.map(
          (thumbnailColumn, thumbnailColumnIndex) => (
            <div
              key={`${thumbnailItem.id}-${thumbnailColumnIndex}`}
              className={css.thumbnailColumn}
            >
              {thumbnailColumn.map((thumbnail, thumbnailIndex) => (
                <div
                  key={`${thumbnailItem.id}-${thumbnailColumnIndex}-${thumbnailIndex}`}
                  className={css.thumbnailImage}
                >
                  <Image
                    src={thumbnail.url}
                    mediavariant={
                      MediaVariants.THUMBNAIL_CROPPED_WITH_BACKGROUND_REMOVED
                    }
                    placeholderMediaVariant={
                      MediaVariants.THUMBNAIL_CROPPED_WITH_BACKGROUND_REMOVED
                    }
                    layout="contain"
                  />
                </div>
              ))}
            </div>
          )
        )
      )}
    </button>
  );
};

export default HTWIItemThumbnail;
